import React, { useState, useEffect } from 'react';
import CardProfile from '../../../components/Profile/Card/';
import ButtonBase from '../../../components/Buttons/ButtonBase';
import { connect } from 'react-redux';
import Snackbar from '../../../components/Snackbar';
import { isMobile } from 'react-device-detect';
import { showLoading, hideLoading } from "../../../store/actions/LoadingActions";
import { Checkbox, FormControlLabel, Tooltip, ClickAwayListener } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { communityForm } from "../../../store/actions/UserAction";
import { updateCheckCommunity } from "../../../configs/environments/firebase/firebaseApp";
import './community.scss'

const useStyles = makeStyles(theme => ({
    colorGrayIcon: {
        color: '#c1c1c1',
        padding: 0,
    },
    TextField: {
        maxWidth: '320px',
        height: 74,
    },
    colorActiveCheckCommunity: {
        color: '#484848',
        fontSize: 16,
        fontWeight: 'bold',
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        margin: 0,
        paddingLeft: 0
    },
    tooltipParagraph: {
        margin: 0,
        fontSize: 14,
        '& b': {
            fontSize: 14,
            fontWeight: 'bold',
        },
    },
    customTooltip: {
        backgroundColor: '#094565',
        margin: '4px 0 0',
        padding: 8,
        maxWidth: 216,
        width: 206,
        lineHeight: 1.2
    },
    colorActiveLabelCommunity: {
        color: '#484848',
        fontSize: 16,
        fontWeight: 'bold',
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        margin: 0,
        paddingLeft: 0
    },
}));


const Community = ({ role, authClient, showLoading, hideLoading, communityForm }) => {


    const classes = useStyles();
    const [communityData, setCommunityData] = useState(false);
    const [feedbackMessage, setFeedbackMessage] = useState({
        open: false,
        message: '',
        variant: 'success'
    });

    useEffect(() => {
        setValidateCommunity();
    }, []);

    const setValidateCommunity = () => {
        let checked = authClient.community === undefined ? true : authClient.community
        setCommunityData(checked)
    }

    const [openTooltip, setTooltip] = useState(false);

    const handleOpenTooltip = () => {
        setTooltip(true);
    };

    const handleCloseTooltip = () => {
        setTooltip(false);
    };

    const handleCloseFeedbackMessage = () => {
        setFeedbackMessage({
            open: false,
            message: '',
            variant: 'success'
        });
    };

    const handleChangeCheckCommunity = () => {
        setCommunityData(!communityData)
    }

    const handleSubmit = async () => {
        showLoading()
        
        let type = 'active';
        if (communityData) {
            type = 'active'
        }else {
            type = 'inactive'
        }
        await updateCheckCommunity(type)
        communityForm(communityData, authClient.uid).then(res => {
            setFeedbackMessage({
                open: true,
                message: 'Tus cambios se han guardado con éxito',
                variant: 'success'
            });
            hideLoading()
        })
            .catch(error => hideLoading())
    }
    return (
        <div className='communitySection'>
            <CardProfile
                title={'Comunidad'}
                subTitle='Sé parte de la comunidad de abogados que ayudan a sus clientes.'
                awardIcon
                status={authClient && authClient.awardPerfil.community ? authClient.awardPerfil.community : false}
            >
                <div className="contentMainCommunity">
                    <div className="contentMainCommunity_container">
                        <FormControlLabel
                            classes={{
                                root: classes.FormControlLabelRoot,
                            }}
                            disabled={
                                authClient &&
                                authClient.membership &&
                                authClient.membership.type &&
                                authClient.membership.type === 'Freemium' ?
                                true : false
                            }
                            control={
                                <Checkbox
                                    name="community"
                                    checked={communityData}
                                    onChange={handleChangeCheckCommunity}
                                    label="Gilad Gray"
                                    classes={{
                                        root: classes.checkPadding,
                                    }}
                                />
                            }
                            label={
                                <>
                                    <div
                                        className={
                                            communityData
                                                ? classes.colorActiveCheckCommunity
                                                : classes.colorActiveLabelCommunity
                                        }
                                    >
                                        <div className="contentTextCheck">
                                            <p
                                                className={
                                                    authClient &&
                                                    authClient.membership &&
                                                    authClient.membership.type &&
                                                    authClient.membership.type === 'Freemium' ?
                                                    "titleCheckDisabled" : "titleCheck"
                                                }
                                            >
                                                Deseo ser parte de la comunidad Contacta Abogado®
                                            </p>
                                        </div>
                                    </div>
                                </>
                            }
                        />

                        {isMobile === true ?
                            <ClickAwayListener onClickAway={handleCloseTooltip}>
                                <Tooltip
                                    onClose={handleCloseTooltip}
                                    open={openTooltip}
                                    disableFocusListener
                                    disableHoverListener
                                    disableTouchListener
                                    classes={{ tooltip: classes.customTooltip }}
                                    title={
                                        <p className={classes.tooltipParagraph}>
                                            Participa para tener más presencia y captar más clientes.
                                        </p>
                                    }
                                    placement='left'
                                >
                                    <img
                                        src="/img/profile/ayuda.png"
                                        alt="?"
                                        onClick={handleOpenTooltip}
                                        className="contentImgHelp"
                                    />
                                </Tooltip>
                            </ClickAwayListener> :
                            <Tooltip
                                classes={{ tooltip: classes.customTooltip }}
                                title={
                                    <p className={classes.tooltipParagraph}>
                                        Participa para tener más presencia y captar más clientes.
                                    </p>
                                }
                                placement='bottom'
                            >
                                <img className="contentImgHelp" src="/img/profile/ayuda.png" alt="?" />
                            </Tooltip>
                        }
                    </div>

                    <ButtonBase
                        type="submit"
                        onClick={handleSubmit}
                        variant="primary"
                        className="buttonSaveChange"
                        classes={{ root: classes.ButtonBase }}
                        disabled={
                            authClient &&
                            authClient.membership &&
                            authClient.membership.type &&
                            authClient.membership.type === 'Freemium' ?
                            true : false
                        }
                    >
                        Guardar cambios
                    </ButtonBase>
                </div>
            </CardProfile>
            <Snackbar
                open={feedbackMessage.open}
                message={feedbackMessage.message}
                variant={feedbackMessage.variant}
                handleClose={handleCloseFeedbackMessage}
                vertical="top"
                horizontal="right"
                snackbarTop={isMobile ? '70px' : '80px'}
            />
        </div>
    );

}

const mapDispatchToProps = dispatch => ({
    communityForm: (data, uid) => dispatch(communityForm(data, uid)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading())
})


const mapStateToProps = state => ({
    authClient: state.authClient,
});

export default connect(mapStateToProps, mapDispatchToProps)(Community);


